import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AuthProvider } from './AuthContext';
// import { Adsense } from '@ctrl/react-adsense';


import Login from './Login';
import Profile from './Profile';
import Category from './Component_CategoryList';
import Questions from './Questions';
import Vouchers from './Vouchers';
import Register from './Register'
import Team from './Team';
import MyScore from './MyScore';
import MyKnowledgeScore from './MyKnowledgeScore';
import Admin from './admin';
import Dashboard from './dashboard';
import Friends from './Friends';
import Leaderboard from './Leaderboard.js';
import Challenges from './Challenges.js';
import Challengeview from './ChallengeView.js';
import ForgotPassword from './ForgotPassword.js';
import AboutUs from './AboutUs.js';
import VoucherRequests from './VoucherRequests.js';
import PointsWeightage from './PointsWeightage.js';


var currentPage = 'Login';
// var currentCategory = '1';


function refreshPageLayout(){

  let paramString = window.location.href.split('?')[1];
  if (paramString) {
    let queryString = new URLSearchParams(paramString);
    for (let pair of queryString.entries()) {
      if (pair[0] === 'pageName') {
        currentPage = pair[1];
      }
      if (pair[0] === 'CategoryName') {
        // currentCategory = pair[1];
      }
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
console.log("Current Page: ", currentPage);

  switch (currentPage) {
    case 'Login':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Login />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'Profile':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Profile />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'MyScore':
        root.render(
          <React.StrictMode>
            <AuthProvider>
              <MyScore />
            </AuthProvider>
          </React.StrictMode>
        );
        break;
    case 'PointsWeightage':
        root.render(
          <React.StrictMode>
            <AuthProvider>
              <PointsWeightage />
            </AuthProvider>
          </React.StrictMode>
        );
        break;    
    case 'Challenges':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Challenges />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'cview':
        root.render(
          <React.StrictMode>
            <AuthProvider>
              <Challengeview />
            </AuthProvider>
          </React.StrictMode>
        );
        break;
    case 'Leaderboard':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Leaderboard />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'MyKnowledgeScore':
          root.render(
            <React.StrictMode>
              <AuthProvider>
                <MyKnowledgeScore />
              </AuthProvider>
            </React.StrictMode>
          );
          break;
    case 'Register':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Register />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'Category':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Category />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'Vouchers':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Vouchers />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'VoucherRequests':
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <VoucherRequests />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'Question':
      root.render(
        <React.StrictMode>
           <AuthProvider>
            <Questions />
          </AuthProvider>
        </React.StrictMode>
      );
      break;    
    case 'Team':
      root.render(
        <React.StrictMode>
           <AuthProvider>
            <Team />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'AboutUs':
      root.render(
        <React.StrictMode>
           <AuthProvider>
            <AboutUs />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
    case 'Friends':
        root.render(
          <React.StrictMode>
             <AuthProvider>
              <Friends />
            </AuthProvider>
          </React.StrictMode>
        );
        break;
    case 'admin':
        root.render(
          <React.StrictMode>
             <AuthProvider>
              <Admin />
            </AuthProvider>
          </React.StrictMode>
        );
        break;      
    case 'Dashboard': 
        root.render(
          <React.StrictMode>
             <AuthProvider>
              <Dashboard />
            </AuthProvider>
          </React.StrictMode>
        );
        break;
    case 'ForgotPassword':
        root.render(
          <React.StrictMode>
              <ForgotPassword />
          </React.StrictMode>
        );
        break;
    default:
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <Profile />
          </AuthProvider>
        </React.StrictMode>
      );
      break;
  }
}
refreshPageLayout(currentPage);